import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'styled-components'
import LayoutView from './view'


const Layout = ({
  children,
  theme,
  breadcrumb,
  profile,
  ...props
}) => {
  
  return (
    <LayoutView
      {...props}
      theme={theme}
      breadcrumb={breadcrumb}
      profile={profile}
    >
      {children}
    </LayoutView>
  )
}

Layout.defaultProps = {
  children: <></>,
  profile: null,
}

Layout.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.object.isRequired,
  breadcrumb: PropTypes.bool,
  profile: PropTypes.object,
}

export default withTheme(Layout)
